<div class="page-content">
    <div class="container-fluid">
        <p>data-table works!</p>
    </div>
</div>